import { render, staticRenderFns } from "./ModeloDelete.vue?vue&type=template&id=1e2079e0&"
import script from "./ModeloDelete.vue?vue&type=script&lang=js&"
export * from "./ModeloDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports